import render from './render'

export default {
  name: 'ComponentNotFound',

  render
}
